import { render, staticRenderFns } from "./PasswordComponent.vue?vue&type=template&id=13ad842c&scoped=true"
import script from "./PasswordComponent.vue?vue&type=script&lang=js"
export * from "./PasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./PasswordComponent.vue?vue&type=style&index=0&id=13ad842c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad842c",
  null
  
)

export default component.exports